import React from "react";
import { AgentSelect } from "./AgentSelect";
import { PromptEditor } from "./PromptEditor";
import type { Agent } from "@/types/agent";
import { Card } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface MainEditPanelProps {
  agents: Agent[];
  selectedAgentId: string;
  prompt: string;
  onAgentSelect: (value: string) => void;
  onPromptChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const MainEditPanel = ({
  agents,
  selectedAgentId,
  prompt,
  onAgentSelect,
  onPromptChange,
}: MainEditPanelProps) => {
  const [learningMode, setLearningMode] = React.useState<string>("general_prompt");

  return (
    <div className="space-y-4">
      <Card className="p-6">
        <div className="space-y-6">
          <AgentSelect
            agents={agents}
            selectedAgentId={selectedAgentId}
            onAgentSelect={onAgentSelect}
          />

          {selectedAgentId && (
            <>
              <div className="space-y-4">
                <div>
                  <h4 className="text-sm font-medium mb-3">Modo de Aprendizado</h4>
                  <RadioGroup 
                    defaultValue="general_prompt" 
                    className="flex flex-col space-y-2"
                    value={learningMode}
                    onValueChange={setLearningMode}
                  >
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="general_prompt" id="general_prompt" />
                      <Label htmlFor="general_prompt">Usar somente prompt geral</Label>
                    </div>
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="sections_only" id="sections_only" />
                      <Label htmlFor="sections_only">Usar somente seções</Label>
                    </div>
                  </RadioGroup>
                </div>

                {learningMode === "general_prompt" && (
                  <PromptEditor
                    prompt={prompt}
                    agentId={parseInt(selectedAgentId)}
                    onPromptChange={onPromptChange}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </Card>
    </div>
  );
};